import Button from "./Button";
import Modal from "./Modal";

interface ConfirmationModalProps {
  title: string;
  message?: string;
  open: boolean;
  closeModal: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmationModal({
  title,
  message,
  confirmButtonText = "Yes",
  cancelButtonText = "No",
  onConfirm,
  onCancel,
  ...modalProps
}: ConfirmationModalProps) {
  return (
    <Modal {...modalProps} smallScreenOnly={false}>
      <div className="bg-grayscale-900 shadow-grayscale-900 w-full gap-4 rounded-lg p-3 text-center shadow">
        <h3 className="mb-2 text-left font-bold">{title}</h3>
        {message ? <p>{message}</p> : <></>}
        <div className="mt-4 flex gap-8">
          <Button onClick={onCancel} variantion="danger">
            <p className="w-20">{cancelButtonText}</p>
          </Button>
          <Button onClick={onConfirm}>
            <p className="w-20">{confirmButtonText}</p>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
